<section class="notifications-container">
    <ng-container *ngIf="viewOnly; else editMode">
        <mat-list dense>
            <mat-list-item *ngFor="let key of keys">
                <mat-icon>{{ notificationSettings[key] ? 'notifications_active' : 'notifications_paused' }}</mat-icon>
                {{ notificationTranslations[key] }}
            </mat-list-item>
        </mat-list>
    </ng-container>

    <ng-template #editMode>
        <div *ngFor="let key of keys"
             class="user-notification-toggle">
            <mat-slide-toggle [(ngModel)]="notificationSettings[key]"
                              [disabled]="isLoadingMap[key]"
                              (change)="onChange(key, $event)">
                {{ notificationTranslations[key] }}
                <mat-icon *ngIf="!controlsAccess[key]">notifications_off</mat-icon>
                <mat-spinner *ngIf="isLoadingMap[key]"
                             [diameter]="20"
                             [strokeWidth]="2">
                </mat-spinner>
            </mat-slide-toggle>
        </div>
        <p *ngIf="hasNotificationWarning"
           class="mat-typography notification-warning">
            <mat-icon>notifications_off</mat-icon> {{ notificationRightsWarning }}
        </p>
    </ng-template>
</section>
